import { isEmpty, values } from 'lodash';

export const getScarcityFlag = (units) => ((!isEmpty(units)) ?
	values(units).some((unit) => unit.quantity !== null && unit.quantity < 4) :
	false
);
